import { defineComponent, PropType } from 'vue'
import { omit } from 'lodash-es'
import GImage from '@/components/GImage'
import SvgIcon from '@/components/svgIcon/index.vue'

import './style.less'

export default defineComponent({
  props: {
    width: [ Number, String ] as PropType<number | string>,
    height: [ Number, String ] as PropType<number | string>,
    url: String as PropType<string>,
    alt: {
      type: String as PropType<string>,
      default: `People's Daily English language App - Homepage - Breaking News, China News, World News and Video`
    },
    isDark: Boolean as PropType<boolean>,
    mobile: Boolean as PropType<boolean>,
    showPlaceHold: {
      type: Boolean as PropType<boolean>,
      default: true
    },
    click: Function as PropType<() => void>
  },
  emits: [ 'load' ],
  setup(props, { attrs, emit }) {
    const loading = ref(true)
    const unit = computed(() => props.mobile ? 'rem' : 'px')

    const mobileConversion = computed(() => {
      return {
        width: props.mobile ? 112 / 37.5 : 112,
        height: props.mobile ? 52 / 37.5 : 52
      }
    })

    const placeHoldStyle = computed(() => {
      const width = Number(props.width) / 2
      return {
        width: `${Number(props.width) / 2}${unit.value}`,
        height: props.showPlaceHold
          ? `${width * mobileConversion.value?.height / mobileConversion.value?.width}${unit.value}`
          : 0,
        maxWidth: `${mobileConversion.value?.width}${unit.value}`,
        maxheight: `${mobileConversion.value?.height}${unit.value}`
      }
    })

    const styles = computed(() => {
      const styleObj = attrs.style || {} as any
      if (!loading.value) delete styleObj.minHeight
      return styleObj
    })

    return () => (
      <GImage
        {...omit(attrs, 'style')}
        lazy
        style={{
          width: `${props.width}${unit.value}`,
          height: props.height ? `${props.height}${unit.value}` : undefined,
          ...styles.value
        }}
        className="real-image"
        src={props.url}
        alt={props.alt}
        onLoad={() => {
          loading.value = false
          emit('load')
        }}
        fallback={(
          <div
            class={[ 'image-slot', props.isDark ? 'dark' : '' ]}
            style={{ minHeight: loading.value ? (attrs?.style as any)?.['minHeight'] : undefined }}
          >
            <SvgIcon style={placeHoldStyle.value} name={props.isDark ? 'image-errorV' : 'image-error'} />
          </div>
        )}
        placeholder={props.showPlaceHold && (
          <div
            class={[ 'image-slot', props.isDark ? 'dark' : '' ]}
            style={{ minHeight: loading.value ? (attrs?.style as any)?.['minHeight'] : undefined }}
          >
            <SvgIcon
              style={placeHoldStyle.value}
              name={props.isDark ? 'image-placeHoldVlogo' : 'image-placeholdLogo'}
            />
          </div>
        )}
      />
    )
  }
})
